// extracted by mini-css-extract-plugin
module.exports = {"Product":"product_Product__YUAVL"};